import toast from 'react-hot-toast';

const getError = (error) => {
  if (error.response) {
        // Request made and server responded
        const { status, data } = error.response;
        toast.error(data.responseMessage ? data.responseMessage : `${status}, Something went wrong`)
      } else if (error.request) {
        // The request was made but no response was received
        toast.error(error.toString());
        console.error(error.toString());
      } else {
        // Something happened in setting up the request that triggered an Error
        toast.error(error.message)
        console.error('Error', error.message);
      }
}

export { getError };
